import { path, createCachedSelector, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { streamSelector, IStream } from '@cbridge-packages/stream';

export const streamConnectedServersSectionPropsSelector = createCachedSelector(
  [
    path(streamSelector).servers(),
  ],
  (streamServers) => {
    return streamServers ?? [];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ streamId: IStream['streamId'] }>().streamId(),
});
